import { getCastRelationshipId } from '../utils/getCastRelationshipId';
import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

export const useCurrentCastRelationship = (castRelationships: ApiV1CastRelationship[]) => {
  const savedCurrentId = getCastRelationshipId();
  const current =
    (savedCurrentId
      ? castRelationships?.find((cr) => cr.castRelationshipId === savedCurrentId)
      : null) ?? castRelationships?.[0];

  const previous =
    castRelationships?.filter((cr) => cr.castRelationshipId !== current?.castRelationshipId) ?? [];

  return { currentCastRelationship: current, previousCastRelationships: previous };
};
